import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Copy, Title, Wrapper } from './styles';
const Header = (props) => {
    const { title, copy } = props;
    return (_jsxs(Wrapper, { children: [_jsx(Title, { children: title }), _jsx(Copy, { children: copy })] }));
};
export default Header;
